// Bridge to get FCM token from native iOS
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Get the FCM token from UserDefaults via Capacitor Preferences
 * The AppDelegate stores the FCM token in UserDefaults when Firebase generates it
 */
export async function getFCMTokenFromNative() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
    return null;
  }

  try {
    // Read the FCM token from UserDefaults (stored by AppDelegate)
    const { value } = await Preferences.get({ key: 'fcmToken' });

    if (value) {
      console.log('FCM token retrieved from native:', value.substring(0, 30) + '...');
      return value;
    }

    console.log('No FCM token available yet from Firebase');
    return null;
  } catch (err) {
    console.error('Error getting FCM token from native:', err);
    return null;
  }
}

/**
 * Poll for FCM token with retry logic
 * Since Firebase might take a moment to generate the token after app launch
 */
export async function waitForFCMToken(maxAttempts = 15, delayMs = 1000) {
  for (let i = 0; i < maxAttempts; i++) {
    const token = await getFCMTokenFromNative();
    if (token) {
      return token;
    }

    // Wait before trying again
    console.log(`Attempt ${i + 1}/${maxAttempts}: Waiting for FCM token...`);
    await new Promise(resolve => setTimeout(resolve, delayMs));
  }

  console.error('FCM token not available after', maxAttempts, 'attempts');
  return null;
}
